module.exports = __webpack_public_path__ + "static/Masterclass-body-7e722c4e07bb0b3f3818fe5bf1bba2dc.jpg";